import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { EthL1PaymentProcessingModuleFlowExecutor } from "./EthL1PaymentProcessingModuleFlowExecutor";
import { EthL1PaymentProcessingPopupSceneOptions } from "./scenes/EthL1PaymentProcessingPopupSceneOptions";
import { MonPaymentProcessingPopupScene } from "./scenes/MonPaymentProcessingPopupScene";
import { ParamDescription } from "../../../composition/module/ParamDescription";
import { Erc20PaymentProcessingResourcePackage } from "./resources/Erc20PaymentProcessingResourcePackage";
import { EthL1PaymentProcessingModel } from "./models/EthL1PaymentProcessingModel";
import { EthL1PaymentProcessingController } from "./controllers/EthL1PaymentProcessingController";
import { PaymentResult } from "../../../../web3/PaymentResult";
import { PaymentProcessingType } from "./type/PaymentProcessingType";
import { CancellationToken } from "../../../../shared/async/CancellationToken";

export class EthL1PaymentProcessingModule extends BaseModule<PaymentResult> {
    private Erc20ResourcePackage: Erc20PaymentProcessingResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(EthL1PaymentProcessingModuleFlowExecutor, EthL1PaymentProcessingModuleFlowExecutor);
        this.internalContainer.register(MonPaymentProcessingPopupScene, MonPaymentProcessingPopupScene);
        this.internalContainer.register("IEthL1PaymentProcessingModel", EthL1PaymentProcessingModel);
        this.internalContainer.register("IEthL1PaymentProcessingController", EthL1PaymentProcessingController);
        this.internalContainer.register("MonSelectPaymentPopupSceneFactory", {
            useValue: async (options: EthL1PaymentProcessingPopupSceneOptions<PaymentProcessingType>, cancellationToken: CancellationToken) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    MonPaymentProcessingPopupScene,
                    new ParamDescription("EthL1PaymentProcessingPopupSceneOptions", options),
                    new ParamDescription(CancellationToken, cancellationToken)
                );
            }
        });

        this.Erc20ResourcePackage = new Erc20PaymentProcessingResourcePackage();
        await this.Erc20ResourcePackage.load();
        this.internalContainer.registerInstance(Erc20PaymentProcessingResourcePackage, this.Erc20ResourcePackage);

        await super.build();
    }

    public async start(options?: EthL1PaymentProcessingPopupSceneOptions<PaymentProcessingType>): Promise<PaymentResult> {
        const executor = await this.internalContainer.resolve(EthL1PaymentProcessingModuleFlowExecutor);
        const result = await executor.execute(this, options);
        this.dispose();
        return result;
    }

    public override dispose(): void {
        this.Erc20ResourcePackage?.destroy();
        super.dispose();
    }
}
